import React from 'react'

const Contact = (props) => {
  return (
    <div className="contato">    
      <a className="texto-intro">
      {props.data.email}
     </a>   
    </div>
  )
}


export default Contact


// WEBPACK FOOTER //
// ./src/Contact.js